import { Grid, Link } from '@material-ui/core';
import { EntityArgoCDOverviewCard } from '@roadiehq/backstage-plugin-argo-cd';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const ArgoCdLink = ({ appName }: { appName: string }) => {
  const config = useApi(configApiRef);
  const argocdUrl = config.getString('app.argocdUrl');

  const url = `${argocdUrl}/applications/${appName}`;

  return (
    <Link href={url} target="_blank">
      View <OpenInNewIcon style={{ fontSize: 14 }} />
    </Link>
  );
};

export const argoCdContent = (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item md={12} xs={12}>
      <EntityArgoCDOverviewCard
        title="ArgoCD Overview"
        extraColumns={[
          {
            align: 'left',
            title: 'Cluster',
            render: (data: any) => {
              return <>{data?.metadata?.labels?.cluster}</>;
            },
          },
          {
            align: 'left',
            title: 'Namespace',
            render: (data: any) => {
              return <>{data?.spec?.destination?.namespace}</>;
            },
          },
          {
            align: 'left',
            title: 'Version',
            render: (data: any) => {
              return <>{data?.status?.summary?.images}</>;
            },
          },
          {
            align: 'right',
            render: (data: any) => {
              return <ArgoCdLink appName={data.metadata.name} />;
            },
          },
        ]}
      />
    </Grid>
  </Grid>
);
